{
  "standingReq": { "mk2": 25, "mk3": 40 },
  "budget": { "minFrac": 0.1, "maxFrac": 0.2, "tolerance": 0.05 },
  "patterns": {
    "authority": {
      "name": "Charter-spec",
      "standingFaction": "authority",
      "maker": "authority",
      "routes": ["standing", "study"],
      "modules": ["shield"],
      "strength": { "stat": "regenMult", "frac": 0.15 },
      "cost": { "stat": "shieldMult", "frac": -0.15 },
      "signatureInput": "electronics"
    },
    "tethys": {
      "name": "Heavy-duty",
      "standingFaction": "tethys",
      "maker": "tethys",
      "routes": ["standing", "study"],
      "modules": ["mining"],
      "strength": { "stat": "heatCapacityMult", "frac": 0.15 },
      "cost": { "stat": "power", "frac": 0.15 },
      "signatureInput": "ti_alloy"
    },
    "meridian": {
      "name": "Lean",
      "standingFaction": "meridian",
      "maker": "meridian",
      "routes": ["standing", "study"],
      "modules": ["cargo"],
      "strength": { "stat": "capacityT", "frac": 0.15 },
      "cost": { "stat": "maxPartMassT", "frac": -0.15 },
      "signatureInput": "silicon_wafers"
    },
    "varro": {
      "name": "Hot",
      "standingFaction": "varro_security",
      "maker": "varro_security",
      "routes": ["standing", "study"],
      "modules": ["pdc", "laser"],
      "strength": { "stat": "damageMult", "frac": 0.15 },
      "cost": { "stat": "power", "frac": 0.15 },
      "signatureInput": "weapon_parts"
    },
    "mutual": {
      "name": "Field-refit",
      "standingFaction": "mutual",
      "maker": "mutual",
      "routes": ["standing", "study"],
      "modules": ["salvage"],
      "strength": { "stat": "spillPerSec", "frac": -0.15 },
      "cost": { "stat": "cutMult", "frac": 0.15 },
      "signatureInput": "radiator"
    },
    "holdfast_old": {
      "name": "Old pattern",
      "standingFaction": null,
      "maker": "first_charter",
      "routes": ["fragments", "study"],
      "modules": ["scanner"],
      "strength": { "stat": "power", "frac": -0.15 },
      "cost": { "stat": "range", "frac": -0.15 },
      "signatureInput": "dataCore"
    }
  }
}
